import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import { Dispatch, FC, SetStateAction } from "react";
import { ExpandedNavigationSubMenuProps } from "../local/expanded-local-navigation";
import { PageListOrLink } from "./page-list-or-link";

interface PageGroupProps {
  pageGroup: ExpandedNavigationSubMenuProps;
  layout: "horizontal" | "vertical";
  setTabOpen: Dispatch<SetStateAction<string>>;
  tabOpen: string;
}
export const PageGroup: FC<PageGroupProps> = ({
  setTabOpen,
  tabOpen,
  pageGroup,
  layout,
}) => {
  const { title, pageListOrLinks } = pageGroup;
  return (
    <>
      {pageListOrLinks && (
        <NavigationMenu.List asChild>
          <div className="expanded-navigation-content-links">
            {title && (
              <div className="expanded-navigation-content-links-label">
                {title}
              </div>
            )}
            <ul>
              {pageListOrLinks.map((pageListOrLink, k) => (
                <PageListOrLink
                  layout={layout}
                  pageListOrLink={pageListOrLink}
                  tab={k}
                  key={k}
                  setTabOpen={setTabOpen}
                  tabOpen={tabOpen}
                />
              ))}
            </ul>
          </div>
        </NavigationMenu.List>
      )}
    </>
  );
};
